import { useCallback, useEffect, useState } from 'react'

import { BigNumber } from '../../sushi'
import {
  getMasterChefAddress,
  getMasterChefContract,
  getPoolWeight,
  getSoccerBakeBlpContract,
  getSoccerContract,
  getSushiContract,
  getBakerySoccerStakingPowerTokenContract,
  getBakerySoccerStakingPowerTokenAddress,
  getDoggyNFTCommonStakeERC721EarnBakeContract,
  getDoggyNFTCommonStakeERC721EarnBakeAddress,
  getDoggyBnbBlpContract,
  getDoggyContract,
  getWethContract,
  getBakeBnbBlpContract,
  getBarkingNFTCommonStakeERC721EarnBakeContract,
  getBarkingNFTCommonStakeERC721EarnBakeAddress,
  getBarkContract,
  getBarkBnbBLpContract,
  getPokerContract,
  getPokerBnbBlpContract,
  getPokerCardStakingPowerTokenContract,
  getPokerCardStakingPowerTokenAddress,
  getDoggyEquipmentCommonStakeERC721EarnBakeContract,
  getDoggyEquipmentCommonStakeERC721EarnBakeAddress,
  getBakeMuskMixerCommonStakeERC721EarnBake2Contract,
  getBakeMuskMixerCommonStakeERC721EarnBake2Address,
  getMasterChef2Address,
  getMasterChef2Contract,
  getDoggyNFTCommonStakeERC721EarnBake2Address,
  getDoggyNFTCommonStakeERC721EarnBake2Contract,
  getTokenPerBlock,
  getBarkingNFTCommonStakeERC721EarnBake2Contract,
  getBarkingNFTCommonStakeERC721EarnBake2Address,
  getPokerCardCommonStakeERC721EarnBake2Contract,
  getPokerCardCommonStakeERC721EarnBake2Address,
  getDoggyEquipmentCommonStakeERC721EarnBake2Contract,
  getDoggyEquipmentCommonStakeERC721EarnBake2Address,
  getBakerySoccerCommonStakeERC721EarnBake2Contract,
  getBakerySoccerCommonStakeERC721EarnBake2Address,
  getBakerySoccerCommonStakeERC721EarnBake3Contract,
  getBakerySoccerCommonStakeERC721EarnBake3Address,
  getDoggyNFTCommonStakeERC721EarnBake3Address,
  getDoggyNFTCommonStakeERC721EarnBake3Contract,
  getBarkingNFTCommonStakeERC721EarnBake3Contract,
  getBarkingNFTCommonStakeERC721EarnBake3Address,
  getPokerCardCommonStakeERC721EarnBake3Contract,
  getPokerCardCommonStakeERC721EarnBake3Address,
  getDoggyEquipmentCommonStakeERC721EarnBake3Contract,
  getDoggyEquipmentCommonStakeERC721EarnBake3Address,
  getBakeMuskMixerCommonStakeERC721EarnBake3Contract,
  getBakeMuskMixerCommonStakeERC721EarnBake3Address
} from '../../sushi/utils'
import useYam from '../bakery/useYam'
import { usePrice } from '../usePrice'
import useBalanceOf from '../useBalanceOf'
import { NFTTYPE } from '../../constants/bakery/nft'
import { userBakeContractVersion } from '../../userType/userBakeContractVersion'

// 传的值 useBlockNum
const useBakerySoccerRoi = (blockNum: BigNumber, type?: string) => {
  const [roi, setRoi] = useState<BigNumber>()
  const bakeContractVersion = userBakeContractVersion(type)

  const sushi = useYam()
  let masterChefAddress = getMasterChefAddress(sushi)
  let masterChefContract = getMasterChefContract(sushi)
  if(bakeContractVersion === 'v2'){
    masterChefAddress = getMasterChef2Address(sushi)
    masterChefContract = getMasterChef2Contract(sushi)
  }

  let stakingPowerToken: any
  let stakingPowerTokenAddress: any
  let tokenBlpContract: any
  let tokenContract: any
  let transferContract: any
  let lp: any = 'bnb'

  switch (type) {
    case NFTTYPE.DOGGIES:
      stakingPowerToken = getDoggyNFTCommonStakeERC721EarnBakeContract(sushi)
      stakingPowerTokenAddress = getDoggyNFTCommonStakeERC721EarnBakeAddress(sushi)
      tokenBlpContract = getDoggyBnbBlpContract(sushi)
      tokenContract = getDoggyContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.DOGGIES_V2:
      stakingPowerToken = getDoggyNFTCommonStakeERC721EarnBake2Contract(sushi)
      stakingPowerTokenAddress = getDoggyNFTCommonStakeERC721EarnBake2Address(sushi)
      tokenBlpContract = getDoggyBnbBlpContract(sushi)
      tokenContract = getDoggyContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.DOGGIES_V3:
      stakingPowerToken = getDoggyNFTCommonStakeERC721EarnBake3Contract(sushi)
      stakingPowerTokenAddress = getDoggyNFTCommonStakeERC721EarnBake3Address(sushi)
      tokenBlpContract = getDoggyBnbBlpContract(sushi)
      tokenContract = getDoggyContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.BARKING:
      stakingPowerToken = getBarkingNFTCommonStakeERC721EarnBakeContract(sushi)
      stakingPowerTokenAddress = getBarkingNFTCommonStakeERC721EarnBakeAddress(sushi)
      tokenBlpContract = getBarkBnbBLpContract(sushi)
      tokenContract = getBarkContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.BARKING_V2:
      stakingPowerToken = getBarkingNFTCommonStakeERC721EarnBake2Contract(sushi)
      stakingPowerTokenAddress = getBarkingNFTCommonStakeERC721EarnBake2Address(sushi)
      tokenBlpContract = getBarkBnbBLpContract(sushi)
      tokenContract = getBarkContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.BARKING_V3:
      stakingPowerToken = getBarkingNFTCommonStakeERC721EarnBake3Contract(sushi)
      stakingPowerTokenAddress = getBarkingNFTCommonStakeERC721EarnBake3Address(sushi)
      tokenBlpContract = getBarkBnbBLpContract(sushi)
      tokenContract = getBarkContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.POKER:
      stakingPowerToken = getPokerCardStakingPowerTokenContract(sushi)
      stakingPowerTokenAddress = getPokerCardStakingPowerTokenAddress(sushi)
      tokenBlpContract = getPokerBnbBlpContract(sushi)
      tokenContract = getPokerContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.POKER_V2:
      stakingPowerToken = getPokerCardCommonStakeERC721EarnBake2Contract(sushi)
      stakingPowerTokenAddress = getPokerCardCommonStakeERC721EarnBake2Address(sushi)
      tokenBlpContract = getPokerBnbBlpContract(sushi)
      tokenContract = getPokerContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.POKER_V3:
      stakingPowerToken = getPokerCardCommonStakeERC721EarnBake3Contract(sushi)
      stakingPowerTokenAddress = getPokerCardCommonStakeERC721EarnBake3Address(sushi)
      tokenBlpContract = getPokerBnbBlpContract(sushi)
      tokenContract = getPokerContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.EQUIPMENT:
      stakingPowerToken = getDoggyEquipmentCommonStakeERC721EarnBakeContract(sushi)
      stakingPowerTokenAddress = getDoggyEquipmentCommonStakeERC721EarnBakeAddress(sushi)
      tokenBlpContract = getDoggyBnbBlpContract(sushi)
      tokenContract = getDoggyContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.EQUIPMENT_V2:
      stakingPowerToken = getDoggyEquipmentCommonStakeERC721EarnBake2Contract(sushi)
      stakingPowerTokenAddress = getDoggyEquipmentCommonStakeERC721EarnBake2Address(sushi)
      tokenBlpContract = getDoggyBnbBlpContract(sushi)
      tokenContract = getDoggyContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.EQUIPMENT_V3:
      stakingPowerToken = getDoggyEquipmentCommonStakeERC721EarnBake3Contract(sushi)
      stakingPowerTokenAddress = getDoggyEquipmentCommonStakeERC721EarnBake3Address(sushi)
      tokenBlpContract = getDoggyBnbBlpContract(sushi)
      tokenContract = getDoggyContract(sushi)
      transferContract = getWethContract(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.BAKEMUSKMIXER:
    case NFTTYPE.BAKEMUSKMIXER_V2:
      stakingPowerToken = getBakeMuskMixerCommonStakeERC721EarnBake2Contract(sushi)
      stakingPowerTokenAddress = getBakeMuskMixerCommonStakeERC721EarnBake2Address(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.BAKEMUSKMIXER_V3:
      stakingPowerToken = getBakeMuskMixerCommonStakeERC721EarnBake3Contract(sushi)
      stakingPowerTokenAddress = getBakeMuskMixerCommonStakeERC721EarnBake3Address(sushi)
      lp = 'bnb'
      break
    case NFTTYPE.SOCCER:
      stakingPowerToken = getBakerySoccerStakingPowerTokenContract(sushi)
      stakingPowerTokenAddress = getBakerySoccerStakingPowerTokenAddress(sushi)
      tokenBlpContract = getSoccerBakeBlpContract(sushi)
      tokenContract = getSoccerContract(sushi)
      transferContract = getSushiContract(sushi)
      lp = 'bake'
      break
    case NFTTYPE.SOCCER_V2:
      stakingPowerToken = getBakerySoccerCommonStakeERC721EarnBake2Contract(sushi)
      stakingPowerTokenAddress = getBakerySoccerCommonStakeERC721EarnBake2Address(sushi)
      tokenBlpContract = getSoccerBakeBlpContract(sushi)
      tokenContract = getSoccerContract(sushi)
      transferContract = getSushiContract(sushi)
      lp = 'bake'
      break
    case NFTTYPE.SOCCER_V3:
      stakingPowerToken = getBakerySoccerCommonStakeERC721EarnBake3Contract(sushi)
      stakingPowerTokenAddress = getBakerySoccerCommonStakeERC721EarnBake3Address(sushi)
      tokenBlpContract = getSoccerBakeBlpContract(sushi)
      tokenContract = getSoccerContract(sushi)
      transferContract = getSushiContract(sushi)
      lp = 'bake'
      break
    default:
      stakingPowerToken = getBakerySoccerStakingPowerTokenContract(sushi)
      stakingPowerTokenAddress = getBakerySoccerStakingPowerTokenAddress(sushi)
      tokenBlpContract = getSoccerBakeBlpContract(sushi)
      tokenContract = getSoccerContract(sushi)
      transferContract = getSushiContract(sushi)
      lp = 'bake'
      break
  }

  // bake转bnb价格
  const bakeBnbPrice =
    usePrice(getBakeBnbBlpContract(sushi), getSushiContract(sushi), getWethContract(sushi)) || new BigNumber(0)
  const totalStakingPower = useBalanceOf(stakingPowerToken, masterChefAddress)
  let tasnferTokenPrice = usePrice(tokenBlpContract, tokenContract, transferContract) || new BigNumber(0)
  if(type === NFTTYPE.BAKEMUSKMIXER){
    tasnferTokenPrice = new BigNumber(0.08)
  }
  let transferSumTokenPrice: any
  switch (type) {
    case NFTTYPE.DOGGIES:
    case NFTTYPE.DOGGIES_V2:
    case NFTTYPE.DOGGIES_V3:
      transferSumTokenPrice = new BigNumber(tasnferTokenPrice.toNumber() * 100000)
      break
    case NFTTYPE.BARKING:
    case NFTTYPE.BARKING_V2:
    case NFTTYPE.BARKING_V3:
      transferSumTokenPrice = new BigNumber(tasnferTokenPrice.toNumber() * 500000)
      break
    case NFTTYPE.POKER:
    case NFTTYPE.POKER_V2:
    case NFTTYPE.POKER_V3:
      transferSumTokenPrice = new BigNumber(tasnferTokenPrice.toNumber() * 1)
      break
    case NFTTYPE.EQUIPMENT:
    case NFTTYPE.EQUIPMENT_V2:
    case NFTTYPE.EQUIPMENT_V3:
      transferSumTokenPrice = new BigNumber(tasnferTokenPrice.toNumber() * 100000)
      break
    case NFTTYPE.BAKEMUSKMIXER:
    case NFTTYPE.BAKEMUSKMIXER_V2:
    case NFTTYPE.BAKEMUSKMIXER_V3:
      transferSumTokenPrice = new BigNumber(tasnferTokenPrice.toNumber() * 1)
      break
  }

  const calculateRoi = useCallback(async () => {
    if(bakeContractVersion === 'v2'){
      masterChefContract = getMasterChef2Contract(sushi)
      blockNum = await getTokenPerBlock(masterChefContract)
      blockNum = new BigNumber(blockNum) || new BigNumber(0)
      blockNum = blockNum.div(new BigNumber(10).pow(18))
    }
    if (transferSumTokenPrice && totalStakingPower && blockNum) {
      const poolWeight = await getPoolWeight(masterChefContract, stakingPowerTokenAddress)
      let roi: any = new BigNumber(0)
      if (lp === 'bnb') {
        roi = totalStakingPower.isFinite()
          ? blockNum
              .times(poolWeight)
              .times(28800)
              .times(365)
              .times(bakeBnbPrice.toNumber())
              .div(
                totalStakingPower
                  .multipliedBy(transferSumTokenPrice)
                  .div(new BigNumber(10).pow(18))
              )
          : new BigNumber(0)
      }

      if (lp === 'bake') {
        roi = totalStakingPower.isFinite()
          ? blockNum
              .times(poolWeight)
              .times(28800)
              .times(365)
              .div(
                totalStakingPower
                .multipliedBy(transferSumTokenPrice)
                .div(new BigNumber(10).pow(18))
              )
          : new BigNumber(0)
      }

      setRoi(roi)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sushi, masterChefContract, tasnferTokenPrice, blockNum, totalStakingPower])

  useEffect(() => {
    if (sushi && masterChefContract && totalStakingPower && blockNum) {
      calculateRoi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sushi, masterChefContract, tasnferTokenPrice, blockNum, totalStakingPower])

  return roi
}

export default useBakerySoccerRoi
